export default class SelectSubstitutionActivityController {
  /** @ngInject */
  constructor(
    $log, $scope, $state, $mdDialog, $mdToast,
    moment,
    SubstitutionService,
    substitutions,
    activities,
    me
  ) {
    this.$log = $log;
    this.$scope = $scope;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.SubstitutionService = SubstitutionService;

    this.substitutions = substitutions;
    this.activities = activities;
    this.me = me;
    this.activityDate = this.moment();

    this.$scope.$watch(() => this.activityDate, (newValue, oldValue) => {
      if (newValue && newValue !== oldValue) {
        this.changeDate(this.moment(newValue).format('YYYY-MM-DD'));
      }
    });
  }

  changeDate(newDate) {
    this.SubstitutionService.getUserActivities(this.me.userId, this.me.employeeId, newDate).then(activities => {
      this.activities = activities;
    });
  }

  select(ev, activity) {
    ev.stopPropagation();
    const params = {
      activityId: String(activity.id)
    };
    this.$state.go('modules.realizations.addBySubstitution', params).then(() => this.cancel());
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
